import React from 'react';
import classnames from 'classnames';

import Shape from 'ati-ui-react/components/Shape';
import Button from '@components/button';

import IconWithActive from '@components/icon-with-active';
import Icon from '@components/icon';
import * as styles from './Banner.scss';
import { openNewTab } from '../../../utils';

const BannerMobile = (props) => {
  const {
    url,
    closeBanner,
    primaryText,
    secondaryText,
    buttonText,
    imageUrl,
    imageAlt = 'banner-image',
    className,
    clickCallback,
    textInOneRow = false,
  } = props;

  const handleClick = () => {
    if (clickCallback) {
      clickCallback();
    }
    openNewTab(url);
  };

  return (
    <Shape
      shadow="true"
      className={classnames(styles.banner, className)}
    >
      <div className={styles.closeButton}>
        <IconWithActive
          defaultIcon={
            <Icon name="ic_close-out" size="s" color="var(--glz-color-neutral-tone-4)" />
          }
          activeIcon={
            <Icon name="ic_close-out" size="s" color="var(--glz-color-neutral-tone-5)" />
          }
          onClick={closeBanner}
        />
      </div>
      <div className={styles.imageContainer}>
        <img
          alt={imageAlt}
          className={styles.image}
          src={imageUrl}
        />
      </div>
      <div className={styles.mainText}>
        <div className={classnames(styles.textContainer, { [styles._row]: textInOneRow })}>
          <span className={styles.text}>
            {primaryText}
          </span>
          {textInOneRow && ' '}
          <span className={classnames(styles.bannerSecondaryText, { [styles._row]: textInOneRow })}>
            {secondaryText}
          </span>
        </div>
        <Button
          onClick={handleClick}
          preventDefault
          className={styles.tryButton}
          theme="success"
          size="small"
        >
          {buttonText}
        </Button>
      </div>
    </Shape>
  );
};

export default BannerMobile;
